import { Box, Typography, SxProps, Theme, useTheme } from '@mui/material';
import React from 'react';

interface BookingFormSectionProps {
  title?: string | React.ReactNode;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  [key: string]: any;
}

const BookingFormSection: React.FC<BookingFormSectionProps> = ({ title, children, sx = {}, ...props }) => {
  const theme = useTheme();

  return (
    <Box sx={{
      mb: 2,
      ...sx
    }} {...props}>
      {title && (
        <Typography
          variant='h4'
          fontWeight={500}
          mt={{
            xs: theme.spacing(0),
            md: theme.spacing(1)
          }}
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  )
};

export default BookingFormSection; 